import { InjectionToken } from '@angular/core';
import { FormOption } from '../../shared/models/form-option.interface';

export const ADDRESS_PROVINCE_FORM_OPTIONS = new InjectionToken<
  FormOption[] | undefined
>('Address Province Form Options');
